import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { install as installOpsContext } from './utils/opsContext';

import 'react-date-range/dist/styles.css'; // react-date-range main style file
import 'react-date-range/dist/theme/default.css'; // treact-date-range heme css file

// Tag API calls with page + action (Daily Ops Stats source) before any request fires.
installOpsContext();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
